import React from 'react';
import styled from 'styled-components';
import Cleanwater from '../../components/Cleanwater/Cleanwater';
import Dn from '../../assets/dn.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardCleanwater extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Cleanwater />

    </Viz>

   <ReusableDetailCard
   trend= {Dn}
   metricsm="Depleting Worldwide"
   diagnosis="Water availability is becoming less predictable in many places, and increased incidences of flooding threaten to destroy water points and sanitation facilities and contaminate water sources (UN Water)."
   prediction="Global water demand is projected to increase by 55 percent between 2000 and 2050 (Resourcewatch). Shortages could have both economic and humanitarian implications."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardCleanwater;
